export const getTotalGuests = (rooms: { adults: number; children: number[] }[]) => {
    return rooms.reduce((total, room) => {
      const adults = room.adults || 0;
      const children = room.children?.length || 0;
      return total + adults + children;
    }, 0);
  };